import qs from 'qs';
import { useQuery } from 'react-query';
import { network } from 'services/network';

import { QueryKeys } from 'api/queryKeys';

const queryFn = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getSegmentsList${querystring}`;
    return network.get(url).then((response) => response.data);
};

export const useQueryGetSegmentsList = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getSegmentsList', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.contractId) && Boolean(params.contractId),
    });
};

interface QueryParams {
    contractId: number | undefined;
    metaDataId: number | undefined;
}

export interface Segment {
    contractId: number;
    entireProject: boolean;
    filter: {
        filters: {
            name: string;
            data: string[];
            operation: string;
        }[];
    };
    name: string;
    segmentId: number;
    taskCount: number;
    url: string;
}

type QueryFnResponse = Segment[];

type QueryResponse = QueryFnResponse & {};
